module.exports = __webpack_public_path__ + "static/media/protect.9c3b78d6.svg";